import React, { useState} from 'react';
import { useHistory } from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import Spinner from 'react-spinkit';
import Container from '@material-ui/core/Container';
import { Button, Grid, Paper, TextField, Typography } from '@material-ui/core';
import useStyles from './styles';
import {fetchLoginRequested} from "../../store/auth/actions";

function LoginPage() {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const [email, setEmail] = useState(null);
  const [password, setPassword] = useState(null);
  const loading = useSelector(state => state.auth.isLoginInProgress);
  const error = useSelector(state => state.auth.error);

  const handleLogin = (event) => {
    event.preventDefault()
    dispatch(fetchLoginRequested({ email, password,loginSucceeded:()=>history.push(`/dashboard/users`) }))
  };

  const inputProps = {
    classes: {
      root: classes.inputRoot,
      notchedOutline: classes.inputNotchedOutline,
      focused: classes.inputFocused
    }
  };
  const inputLabelProps = {
    classes: {
      root: classes.inputLabelRoot,
      focused: classes.inputFocused
    }
  };
  if (loading) {
    return (
      <div>
        <Spinner name="circle" className="spinner" fadeIn="quarter" color="#3897dc"/>
        <div className="overlay"></div>
      </div>
    );
  }
  return (
    <div className={classes.pageWrapper}>
      <Container maxWidth="md" className={classes.pageContainer}>
        <Grid xs={4} xl={4} sm={4} item={1}>
          <Paper elevation={1}>
            <form  className={classes.boxWrapper}
                   onSubmit={handleLogin}
            >
              {
                error &&
                <div className="form-group">
                  <div className="alert alert-danger">
                    <strong>Ошибка!</strong> {error}
                  </div>
                </div>
              }
              <Typography  color="textSecondary" variant="subtitle1">Вход</Typography>
              <TextField InputLabelProps={inputLabelProps} InputProps={inputProps} name="email"
                         onChange={event => setEmail(event.target.value)} label="Email" type="email" variant="outlined"
                         fullWidth margin="normal"/>
              <TextField InputLabelProps={inputLabelProps} InputProps={inputProps} name="password"
                         onChange={event => setPassword(event.target.value)} label="Пароль" type="password"
                         variant="outlined" fullWidth margin="normal"/>
              <Button
                variant="contained"
                type={'submit'}
                fullWidth size="large">Войти</Button>
            </form>
          </Paper>
        </Grid>
      </Container>
    </div>
  );
}

export default LoginPage;



// WEBPACK FOOTER //
// ./src/pages/LoginPage/index.jsx